import styled from 'styled-components';
export const StyledProgressIndicator = styled.div.withConfig({
  displayName: "ProgressIndicatorstyles__StyledProgressIndicator",
  componentId: "sc-17bea2v-0"
})(["transition:all 0.6s ease-in-out;position:fixed;right:0;left:0;top:0;z-index:20;"]);
export const ProgressIndicatorWrapper = styled.div.withConfig({
  displayName: "ProgressIndicatorstyles__ProgressIndicatorWrapper",
  componentId: "sc-17bea2v-1"
})(["height:8px;border-radius:0 3px 3px 0;overflow:hidden;& > *{height:8px !important;border-radius:0 !important;}& > * > *{height:8px !important;background:#eaf0f6 !important;border-radius:0 !important;}& [role='progressbar']{background:#ff5c35;border-radius:0;height:8px;}"]);